// AD-2227: a category the school has taken off its list still shows on a child's profile where it is ticked, marked out of use,
// so a school admin can see it and untick it.
export const withOutOfUse = (categories, selected) => [
    ...categories,
    ...(selected ?? []).filter(held => !categories.some(category => category.id === held.id))
        .map(held => ({...held, outOfUse: true}))
];

export const categoryLabel = category => `${category.number ?? ''} ${category.shortDescription}${category.outOfUse ? ' (out of use)' : ''}`.trim();
